import EnvSettings from "./EnvSettings";

class TagsApi {
  baseUrl = EnvSettings.url;

  GetAllTagsUrl = "Tags";
  GetAllTagsWithAssociationUrl = "AllTagsWithLeadsAndCandidates";
  DeleteTagUrl = "DeleteTag";
  CreateTagUrl = "CreateTag";
  AssociateTagUrl = "AssociateTag";
  DisassociateTagUrl = "DisassociateTag";

  async GetAllTags() {
    try {
      const response = await fetch(`${this.baseUrl}${this.GetAllTagsUrl}`, {
        method: "POST",
      });

      return await response.json();
    } catch (error) {
      console.error("Error fetching tags:", error);
      throw error;
    }
  }

  GetAllTagsWithAssociation = async () => {
    try {
      const response = await fetch(
        `${this.baseUrl}${this.GetAllTagsWithAssociationUrl}`,
        {
          method: "POST",
        }
      );
      return await response.json();
    } catch (error) {
      console.error("Error fetching tags:", error);
      throw error;
    }
  };

  DeleteTag = async (tagId) => {
    try {
      const response = await fetch(`${this.baseUrl}${this.DeleteTagUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: tagId }),
      });
      // console.log("Tag successfully deleted:", response.data);
      return await response.json();
    } catch (error) {
      console.error("Failed to delete the tag:", error.message);
    }
  };

  CreateTag = async (tagData) => {
    try {
      const response = await fetch(`${this.baseUrl}${this.CreateTagUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(tagData),
      });

      return await response.json();
    } catch (error) {
      console.error("Failed to create the tag:", error.message);
      throw error;
    }
  };

  AssociateTag = async (data) => {
    console.log({ data });
    try {
      const response = await fetch(`${this.baseUrl}${this.AssociateTagUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      // console.log("Tag successfully associated", response.data);
      return await response.json();
    } catch (error) {
      console.error("Failed to associate the tag:", error.message);
      throw error;
    }
  };

  DisassociateTag = async (data) => {
    console.log({ data });
    try {
      const response = await fetch(
        `${this.baseUrl}${this.DisassociateTagUrl}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );
      // console.log("Tag successfully disAssociated", response.data);
      return await response.json();
    } catch (error) {
      console.error("Failed to disAssociate the tag:", error.message);
      throw error;
    }
  };
}

export default new TagsApi();
